// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_DISABLED = false;
export const DEFAULT_MODE = 'light';
export const DEFAULT_INPUT_WIDTH = '100%';
export const DEFAULT_SIZE = 's';
//# sourceMappingURL=InputNumber.constants.js.map